module.exports = __webpack_public_path__ + "img/profile_box_gray_playstyle.0ec3d9db.svg";